import WYSIWYGContent from "../WYSIWYGContent/WYSIWYGContent";

export const QIPSpecifications = ({ data }) => {
  const title = data?.title || "Specifications";
  const items = data?.items || [];

  return (
    <div className="px-4 my-8">
      <div className="max-w-restricted mx-auto">
        <h2 className="text-center text-4xl text-gray mb-10">{title}</h2>

        <div className="border-t border-solid border-gray pt-4">
          {items.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-1 sm:grid-cols-2 border-b border-solid border-gray pb-4 mb-4"
            >
              <div className="text-base text-jay-blue font-bold">
                {item.label}
              </div>

              <div className="text-base font-semibold">
                <WYSIWYGContent
                  content={item.description}
                  slimline={true}
                  marginBottom="0px"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
